import { Modal, Row, Col } from "antd";
import Toolbar from "components/Toolbar/index";
import { Flex, Box, Text } from "@chakra-ui/react";
import { CloseModalButton } from "components/Button/CloseModalButton";
import FooterModal from "components/Button/FooterModal";
import colors from "core/resources/theme/colors";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";
import { useState } from "react";
import {
  ClientesQueryParams,
  ClienteSituacao,
} from "core/features/cliente/typings";
import InputMoney from "components/Input/InputMoney/index";
import FiltroTagStatus from "./components/FiltroTagStatus";
import { defaultFiltroClientes } from "./../../hooks/useFiltroClientes";
import InputCpfCnpj from "ui/components/Input/InputCpfCnpj";

interface ModalFiltroClientesProps {
  open: boolean;
  onClose: () => any;
  filtro: ClientesQueryParams;
  onChangeFiltro: (_filtro: Partial<ClientesQueryParams>) => void;
  onReset: () => void;
}

export default function ModalFiltroClientes({
  onClose,
  open,
  filtro,
  onChangeFiltro,
  onReset,
}: ModalFiltroClientesProps) {
  const [localFiltro, setLocalFiltro] = useState(filtro);

  const numeroFiltroSelecionados =
    (localFiltro.documento ? 1 : 0) +
    (localFiltro.tempoFimContrato || localFiltro.tipoIntervaloTempoFimContrato
      ? 1
      : 0) +
    (localFiltro.situacao ? 1 : 0);

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      destroyOnClose
      closable={false}
      className="antd-custom-header"
      width="900px"
      title={<Toolbar title="Filtrar" onClose={onClose} border="0px" />}
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            bg={colors.gray50}
            showBorder={false}
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
              onClose();
            }}
            onClose={() => {
              onReset();
              setLocalFiltro(defaultFiltroClientes);
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText={`Filtrar ${
              typeof numeroFiltroSelecionados === "number" &&
              numeroFiltroSelecionados > 0
                ? ` (${numeroFiltroSelecionados})`
                : ""
            }`}
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      <Text fontWeight="bold" mb="10px">
        CPF/CNPJ
      </Text>
      <Box as={Row} mb={4} gutter={16}>
        <Box as={Col} md={24} mb={4}>
          <InputCpfCnpj
            placeholder="Digite..."
            onChange={(documento: string) => {
              setLocalFiltro((state) => ({
                ...state,
                documento: documento.replace(/\D/g, ""),
              }));
            }}
            value={localFiltro.documento}
          />
        </Box>
      </Box>

      <Text fontWeight="bold" mb="10px">
        Tempo para o fim do contrato
      </Text>
      <Box as={Row} mb={4} gutter={16}>
        <Box as={Col} md={4} mb={4}>
          <InputMoney
            onChange={(tempoFimContrato) => {
              setLocalFiltro((state) => ({
                ...state,
                tempoFimContrato,
              }));
            }}
            value={localFiltro.tempoFimContrato}
            placeholder="0"
            step={1}
            decimalScale={0}
            decimalsLimit={0}
          />
        </Box>
        <Box as={Col} md={4} mb={4}>
          <SelectIntervaloPeriodo
            defaultValue={null}
            onChange={(tipoIntervaloTempoFimContrato) => {
              setLocalFiltro((state) => ({
                ...state,
                tipoIntervaloTempoFimContrato,
              }));
            }}
            value={localFiltro.tipoIntervaloTempoFimContrato}
            getPopupContainer={() => document.body}
            placeholder="selecione"
            plural={localFiltro.tempoFimContrato !== 1}
          />
        </Box>
      </Box>

      <Text fontWeight="bold" mb="10px">
        Situação
      </Text>
      <FiltroTagStatus
        selectedTipoStatus={localFiltro.situacao}
        setSelectedTipoStatus={(status) =>
          setLocalFiltro((state) => ({
            ...state,
            situacao: status as ClienteSituacao,
          }))
        }
      />
    </Modal>
  );
}
